import React, { useState } from 'react';
import { Button, Tooltip } from 'reactstrap';
import { getBaseUrl } from '../../utils/utils';

const CopyInviteLink = ({ inviteCode, role, label,
    customCopyLink,
}) => {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [copied, setCopied] = useState(false);

    const buttonId = `copy-link-${inviteCode}`;



    // Construct the invitation URL
    const inviteUrl =
        customCopyLink ||
        `${getBaseUrl()}/register?inviteCode=${inviteCode}${role ? `&role=${role}` : ''}`;

    const handleCopyClick = () => {
        navigator.clipboard.writeText(inviteUrl)
            .then(() => {
                setCopied(true);
                setTooltipOpen(true);

                // Hide the tooltip after 2 seconds
                setTimeout(() => {
                    setTooltipOpen(false);
                    // Reset copied state after tooltip disappears
                    setTimeout(() => setCopied(false), 300);
                }, 2000);
            })
            .catch(err => {
                console.error('Failed to copy: ', err);
            });
    };

    return (
        <>
            <Button
                id={buttonId}
                onClick={handleCopyClick}
                className="btn btn-primary border border-primary py-2 d-flex align-items-center ms-2 me-2"
            >
                <i className={`mdi mdi-${copied ? 'check' : 'content-copy'} me-3`}></i>
                {copied ? 'Copied!' : label || 'Copy Invite Link'}
            </Button>

            {/* <Tooltip
                isOpen={tooltipOpen}
                target={buttonId}
                toggle={() => setTooltipOpen(!tooltipOpen)}
            >
                Copied to clipboard
            </Tooltip> */}
        </>
    );
};

export default CopyInviteLink;